<div class="version-checker-component">
  <ng-lottie
    [options]="lottieConfig"
    width="160px"
    height="160px"
  ></ng-lottie>
  <!-- <div class="close-button">
    <ion-button fill="clear" color="dark" (click)="closeModal()" class="ion-no-padding">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div> -->
  <ion-grid>
    
    <ion-row class="img-wrapper-row">
      <small class="abs-version">(v{{version}})</small>
      <ion-col size="12" class="text-wrapper pt-0 mt-0">
        <h4>{{"Update Available" | translate}}</h4>
        <p>{{"A new version of the app is available. Please update to continue using the app." | translate}}</p>
      </ion-col>
      <ion-col size="12">
        <ion-button fill="solid" color="primary" expand="block" (click)="redirectToStore()">{{"Update" |
          translate}}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>